import { render, staticRenderFns } from "./PaymentSettingGroupBlock.vue?vue&type=template&id=1ba82382&scoped=true&"
import script from "./PaymentSettingGroupBlock.vue?vue&type=script&lang=js&"
export * from "./PaymentSettingGroupBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba82382",
  null
  
)

export default component.exports